export const globalContentNavigation = ({query = "[data-navigation]"}) => {
    const navigationElements = [...document.querySelectorAll(query)].map((item, index) => {
        if (!item.id) {
            item.id = `content-navigation-item-${index}`
        }

        return createContentNavigationItem({
            id: item.id,
            level: getHeadlineLevel(item),
            header: item.textContent,
            subheader: item.nextElementSibling?.textContent || "",
        })
    })

    insertAndCreateContentNavigation(navigationElements)
}

const insertAndCreateContentNavigation = (items) => {
    const template = document.querySelector("template#content-menu")
    if (template instanceof HTMLTemplateElement && items.length > 0) {
        document.querySelector(".layout-default").classList.replace("layout-default", "layout-content-navigation")

        const contentNavigation = template.content.cloneNode(true)
        const list = contentNavigation.querySelector("ul")

        if (list instanceof HTMLUListElement) {
            items.forEach(item => {
                list.appendChild(item)
            })
        }

        template.parentNode.insertBefore(contentNavigation.firstChild, template)

        return true
    }

    return false
}

const createContentNavigationItem = ({id, level, header, subheader = ""}) => {
    const template = document.querySelector("template#content-menu-item")
    if (template instanceof HTMLTemplateElement) {
        const itemTemplate = template.content.cloneNode(true)
        const listItem = itemTemplate.querySelector("li");
        const linkItem = itemTemplate.querySelector("a")

        if (listItem instanceof HTMLLIElement) {
            const className = listItem.getAttribute("class")
            listItem.setAttribute("class", className.replace('template', level))
        }

        if (linkItem instanceof HTMLAnchorElement) {
            linkItem.href = `#${id}`
            linkItem.firstElementChild.textContent = header
            linkItem.lastElementChild.textContent = subheader
        }

        return itemTemplate.firstChild
    }
}

const getHeadlineLevel = (element) => {
    if (element instanceof HTMLHeadingElement) {
        return element.tagName.slice(-1)
    }

    return "unset"
}
